
import React from 'react'
import BlogHero from '../components/blogPage/BlogHero'
import YogaCards from '../components/blogPage/YogaCards'

const Blog = () => {
  
  
  return (
    <>
   <BlogHero/>
   <YogaCards/>
    </>
  )
}

export default Blog